export default "__VITE_ASSET__AFdwW6Xf__"